import { render, staticRenderFns } from "./SchoolyearPlanning.vue?vue&type=template&id=4012cd46&scoped=true"
import script from "./SchoolyearPlanning.vue?vue&type=script&lang=js"
export * from "./SchoolyearPlanning.vue?vue&type=script&lang=js"
import style0 from "./SchoolyearPlanning.vue?vue&type=style&index=0&id=4012cd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4012cd46",
  null
  
)

export default component.exports